module.exports = __webpack_public_path__ + "img/icon-template.38d78972.svg";